import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { ExampleComponent } from './example.component';


const routes: Routes = [
  {
    path: 'example',
    component: ExampleComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class ExampleRoutingModule {}
